export default "__VITE_ASSET__BNKWMPx4__"